var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"google-login-btn",class:{border: _vm.showBorder},attrs:{"id":"googleLoginButton"},on:{"click":_vm.click}},[_c('img',{attrs:{"src":"/img/icons/google.png","alt":"Google logo"}}),(_vm.isLogin)?_c('span',[_vm._v("Sign in with Google")]):_c('span',[_vm._v("Sign up with Google")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }